@if (view == 1) {
  <ng-content select="[menu1]"></ng-content>
}
@if (view == 2) {
  <ng-content select="[menu2]"></ng-content>
}
